import { ErrorOutline } from "@mui/icons-material";
import { Button, CircularProgress, InputBase } from "@mui/material";
import axios from "axios";
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import ResetLinkSentModal from "../modals/ResetLinkSentModal";

const ForgotPassword = () => {
  const navigate = useNavigate()
  const [errorMsg, setErrormsg] = useState(null);
  const [openSuccessModal, setOpenSuccessModal] = useState(false)
  const [loader, setLoader] = useState(false);
    const [user, setUser] = useState({
      email:'',
    })

   


    async function sendResetLink(){
      setErrormsg(null)
     
      setLoader(true);
      console.log(user)
      try {

        let user_ = await axios
        .post(
          process.env.REACT_APP_BACKEND_URL + "user/get-user-by-email",
          {
            email : user.email,
            
             
          }
        )

        console.log(user_)

        console.log({ email : user.email,
          organization_id:  user_?.data?.user?.relatedOrgs?.L[0]?.M?.org_id?.S || null,
          toName: user_.data.user.fName.S +' '+user_.data.user.lName.S ,
          user_id : user_.data.user.userId.S})
  
        let response = await axios
        .post(
          process.env.REACT_APP_BACKEND_URL + "email/send-reset-link",
          {
            email : user.email,
            organization_id:  user_?.data?.user?.relatedOrgs?.L[0]?.M?.org_id?.S || null,
            toName: user_.data.user.fName.S +' '+user_.data.user.lName.S ,
            user_id : user_.data.user.userId.S
             
          }
        )
        console.log(response)
    
        
        setOpenSuccessModal(true)
        setLoader(false);
  
      } catch (error) {
        console.log(error);
        if (error.response && error.response.data) {
          console.error("Response data:", error.response.data);
          setErrormsg(error.response.data.message);
        }
        setLoader(false);
      }
    }
  return (
    <div className=" lg:flex justify-center lg:pt-[140px]">
     
      <div className=" lg:pt-[20px] pt-[140px] bg-white lg:h-fit h-[100vh] px-8  lg:my-0  lg:w-[30vw]">
      <ResetLinkSentModal open={openSuccessModal} setOpen={setOpenSuccessModal} email={user.email}/>
       
        <div className="flex items-center justify-center">
          <img src="/icons/login_img.png" className="w-[50px]" />
        </div>
        <div className="text-center lg:text-[16px] mt-4  font-semibold ">
         Forgot Password
        </div>

        {errorMsg && (
        <div className="text-center text-red-500 lg:text-[13px] text-[12px] mt-2 flex justify-center  items-center  font-semibold mb-3">
          <ErrorOutline sx={{ fontSize: "",mr:'2px' }} /> {errorMsg}
        </div>
      )}

        <div className="space-y-2 mb-3 mt-4">
          <div className=" lg:text-[14px] text-[13px] ">Email Address</div>
          <InputBase
           value={user.email}
           onChange={(e)=> setUser({...user, email: e.target.value})}
            sx={{
              bgcolor: "#F7F7F8",
              width: "100%",
              px: 2,
              py: "2px",
              fontSize: "14px",
            }}
          />
        </div>

      

     

        <div className="flex justify-center pt-6 pb-4 space-x-2">
          <Button
            sx={{
              textTransform: "none",
              bgcolor: "#605BFF",
              color: "white",
              py: "6px",
              px: "40px",
              borderRadius: "7px",
              fontSize: { lg: "14px", xs: "13px" },
              width: "100%",
            }}
            onClick={()=> {
              sendResetLink()
            }}
          >
             {loader ? (
            <CircularProgress size={"1rem"} sx={{ color: "white" }} />
          ) : (
            "   Reset Your Password"
          )}
         
          </Button>
        </div>

       
      </div>
    </div>
  );
};

export default ForgotPassword;
